import { TextBox } from '@apply/components';
import { AddressFieldLength } from '@apply/constants';
import { useBorrowerEntityStreet2 } from '../../../../../../../queries/BorrowerFields/EntityFields';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface BorrowerStreet1Props {
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
}

export const BorrowerStreet2: React.FC<BorrowerStreet1Props> = ({ required = false, readOnly = false, isReview = false }) => {
    const label = 'Street Address Line 2';
    const [street2, set_street2] = useBorrowerEntityStreet2();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={street2}
                />
            ) : (
                <TextBox
                    value={street2 ?? undefined}
                    onChange={(value) => set_street2(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                    maxLength={AddressFieldLength.street2}
                />
            )}
        </>
    );
};
